module.exports = __webpack_public_path__ + "static/media/remove.c4086e65.svg";